'use client'
import { useEffect } from 'react';
// import { useRouter } from 'next/navigation';

export const useUnsavedAlert = (hasUnsaved, message = 'There may be unsaved changes. Leave anyway?') => {

  // Intercept browser based navigation away: tab close / refresh / typing a new URL
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsaved) {
        event.preventDefault();
        event.returnValue = message; // modern browsers ignore the text
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsaved, message]);

  // Intercept Next.js based navigation away
  // const router = useRouter();
  // const originalPushRef = useRef(router.push);

  useEffect(() => {
    if (!hasUnsaved) return; // if we have nothing unsaved we can return

    // // Wrap router.push so we can ask the user
    // router.push = (url, options) => {
    //   if (window.confirm(message)) {
    //     originalPushRef.current.call(router, url, options);
    //   }
    // };

    // Intercept Next <Link> clicks via pure DOM
    const handleClick = (event) => {
      const anchor = event.target.closest('a[href]');
      if (!anchor) return;

      const url = anchor.href;
      if (window.location.origin !== new URL(url).origin) return; // external link

      if (!window.confirm(message)) {
        event.preventDefault();
      }
    };
    document.addEventListener('click', handleClick, true);

    // Unloads listener when all is well
    return () => {
      // router.push = originalPushRef.current; // restore
      document.removeEventListener('click', handleClick, true);
    };
  }, [hasUnsaved, message]);
};
